import ReactGA4 from 'react-ga4'

// React runs child effects before parent effects, so a page-level effect firing an event beats
// _app's initGA() to it — on a first-paint landing (most SEO traffic) the event was dropped
// because ReactGA4 had not been initialised yet. Only page_view survived, because initialize()
// sends that itself. Initialising lazily on first use removes the ordering dependency.
let initialised = false

function ensureInitialised(): boolean {
  if (initialised) return true
  if (typeof window === 'undefined') return false
  const id = process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID
  if (!id) return false
  try {
    ReactGA4.initialize(id)
    initialised = true
  } catch (error) {
    console.error('GA Initialization Error: ', error)
  }
  return initialised
}

/**
 * Google Analytics
 */
export function useGA() {
  const initGA = () => {
    ensureInitialised()
  }

  const logEventGA = (action: string, params?: any) => {
    // Guarded rather than assumed: a dropped event is silent, and silence reads as "no traffic".
    if (!ensureInitialised()) return
    try {
      ReactGA4.gtag('event', action, params)
    } catch (error) {
      console.error('GA Log Event Error: ', error)
    }
  }

  return { initGA, logEventGA }
}
